<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4 7V5.5C4 4.67157 4.67157 4 5.5 4H7M4 13V14.5C4 15.3284 4.67157 16 5.5 16H7M13 4H14.5C15.3284 4 16 4.67157 16 5.5V7M16 13V14.5C16 15.3284 15.3284 16 14.5 16H13M10 7.75V10M10 10V12.25M10 10H7.75M10 10H12.25" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'WhitelabelSettingsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>